import React from "react";
import { Link, withRouter } from "react-router-dom";
import logo from "../assets2/mate-crunch-logo-5.png"
import "../assets/authentication.css"
import "../assets/landing.css";
import  Footer from "./FooterPage";

class LandingPage extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = { 
      loginModal: false,
      register: false,
      forgotPass: false,
      loading: false,
      username: '',
    };
    this.teamRef = React.createRef()
    this.prodRef = React.createRef()
    this.purchRef = React.createRef()
    this.feedbackRef = React.createRef()
  }

  handleClickOutside = event => {
    if (this.prodRef && this.prodRef.current.contains(event.target)) {
      document.getElementsByClassName('nb_first_mi')[0].style.borderBottom= "1px solid #fff";
    }
    else if (!this.prodRef.current.contains(event.target)){
      document.getElementsByClassName('nb_first_mi')[0].style.borderBottom= "";
    }
    if (this.teamRef && this.teamRef.current.contains(event.target)) {
      document.getElementsByClassName('nb_thrd_mi')[0].style.borderBottom= "1px solid #fff";
    }
    else if (!this.teamRef.current.contains(event.target)){
      document.getElementsByClassName('nb_thrd_mi')[0].style.borderBottom= "";
    }
    if (this.purchRef && this.purchRef.current.contains(event.target)) {
      document.getElementsByClassName('nb_frth_mi')[0].style.borderBottom= "1px solid #fff";
    }
    else if (!this.purchRef.current.contains(event.target)){
      document.getElementsByClassName('nb_frth_mi')[0].style.borderBottom= "";
    }
    if (this.feedbackRef && this.feedbackRef.current.contains(event.target)) {
      document.getElementsByClassName('nb_fifth_mi')[0].style.borderBottom= "1px solid #fff";
    }
    else if (!this.feedbackRef.current.contains(event.target)){
      document.getElementsByClassName('nb_fifth_mi')[0].style.borderBottom= "";
    }
  };

  componentDidMount(){
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleLoginModal = () => {
    this.setState({loginModal: true})
  }

  handleCloseModal = () => {
    this.setState({loginModal: false, loading: false})
  }

  handleRegister = (val) => {
    this.setState({register: val})
  }
  handlePF = (val) => {
    this.setState({forgotPass: val})
  }
  handleLoading = (val) => {
    this.setState({loading: val})
  }

  handleLoadingCounter = async (val) => {
    setTimeout(
      function() {
          this.setState({ loading: !val });
      }
      .bind(this),
      5000
  );
  }

  render() {
    return (
      <body id="landing-page">
        <div className="main-flex-container">
              <div className="top-header-container">
                <div className="lp_header">
                  <Link to="/product">
                    <div id="logo">
                      <div className="logo_container">
                        <div className="lc_first_row">
                          <img className="logo-img" src={logo}></img>
                          <h1>Mate Crunch</h1>
                        </div>
                      </div>
                    </div>
                  </Link>
                  <div className="nav_bar">
                    <div ref={this.prodRef} className="nb_first_mi">
                      <Link to="/product">
                        What is Mate Crunch?
                      </Link>
                    </div>
                    <div ref={this.teamRef}  className="nb_thrd_mi">
                      <Link to="/team">
                        Meet the Team
                      </Link>
                    </div>
                    <div ref={this.purchRef}   className="nb_frth_mi _3X-TCckY_45DQl6YEoqiC1">
                      <Link to="/purchase">
                      <b>Purchase</b>
                      </Link>
                    </div>
                    <div ref={this.feedbackRef}   className="nb_fifth_mi _3X-TCckY_45DQl6YEoqiC1">
                      <Link to="/feedback">
                      <b>Feedback+Rewards</b>
                      </Link>
                    </div>
                  </div> 
                </div>
              </div>
              {this.props.children}
         <Footer/>
        </div>
      </body>
      );
  }
}

export default withRouter(LandingPage);